// extracted by mini-css-extract-plugin
export default {"readOnly":"Fq248Y","disabled":"UX2vmi"};